import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import BackIcon from '@mui/icons-material/ArrowBack';
import Toolbar from '@mui/material/Toolbar';

import { FormattedMessage, useIntl } from 'react-intl';
import Spacings from '~/modules/ui-kit/spacings';

import ContentView from '~/components/ContentView';
import AbsenceForm from '~/components/AbsenceForm';
import { useTheme } from '@mui/material';
import messages from './messages';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { useCreateAbsence } from '~/hooks/api/useCreateAbsence';
import { usePublisherMe } from '~/hooks/api/usePublisherMe';
import { getRouteApi, useNavigate } from '@tanstack/react-router';

const route = getRouteApi('/absences/create');

const AbsenceCreate = () => {
  const theme = useTheme();
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const publisherQuery = usePublisherMe();
  const search = route.useSearch();
  const navigate = useNavigate();
  const publisherId = search.publisherId || publisherQuery.data?.id.toString();
  const handleBackButton = () => {
    navigate({ to: search.from || '/availability', search: { publisherId } });
  };

  const mutation = useCreateAbsence(
    publisherId ? parseInt(publisherId, 10) : undefined,
    {
      onError() {
        showSnackbar({
          message: intl.formatMessage(messages.saveFailure),
        });
      },
      onSuccess() {
        showSnackbar({
          message: intl.formatMessage(messages.saveSuccess),
        });
        navigate({
          to: search.from || '/availability',
          search: { publisherId },
        });
      },
    }
  );

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <Spacings.Inline alignItems="center">
              <IconButton
                color="inherit"
                onClick={handleBackButton}
                size="large"
              >
                <BackIcon data-testid="back" />
              </IconButton>
              <div style={{ marginLeft: theme.spacing(2) }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'inherit',
                  }}
                >
                  <FormattedMessage {...messages.title} />
                </Typography>
              </div>
            </Spacings.Inline>
          </Toolbar>
        </AppBar>
      }
      isLoading={mutation.isPending || publisherQuery.isLoading}
    >
      <AbsenceForm onSubmit={mutation.mutate} />
    </ContentView>
  );
};

export default AbsenceCreate;
